import React from 'react'

import { makeFichaAvisoURL } from '@navent-jobs/interlinking'

// ui-kit
import { Row, Col, ContainerFluid, Container } from '@navent-jobs/ui-kit/components/grid'

// mixins
import {
  ModalComponent,
  ModalBodyComponent,
  ModalBodyContent,
  ModalFooterComponent,
  CardContainer,
  CustomLink,
  CenterDiv,
} from './mixins'

import Card from '../../card'
import ListadoAvisosPlaceholder from '../../../pages/listado-avisos/components/card/ListadoAvisosPlaceholder'

const CONFIDENCIAL = 'Confidencial'
const TOTAL_CARDS_PLACEHOLDER = 5

interface ModalAvisosProps {
  width: number
  visible: boolean
  closeModal: Function
  avisos?: any
  title: string | React.ReactElement
  subtitle: string
  primaryButtonAction: () => void
  primaryButtonText: string
  onClickAviso?: Function
  labsParams?: string
  emptyComponent?: React.ReactElement
  loading?: boolean
}

const ModalFooter = ({ primaryButtonAction, primaryButtonText }) => {
  return (
    <ModalFooterComponent>
      <Container>
        <CenterDiv>
          <CustomLink
            linkoptions={{ variant: 'primary', type: 'link', size: 'medium', block: true }}
            onClick={primaryButtonAction}
          >
            {primaryButtonText}
          </CustomLink>
        </CenterDiv>
      </Container>
    </ModalFooterComponent>
  )
}

const ModalAvisosRecomendados = ({
  primaryButtonAction,
  primaryButtonText,
  width,
  visible,
  closeModal,
  avisos,
  title,
  subtitle,
  onClickAviso,
  labsParams = '',
  emptyComponent,
  loading,
}: ModalAvisosProps) => {
  const closeModalHandler = () => {
    closeModal()
  }

  const clickAvisoHandler = (event, aviso) => {
    onClickAviso && onClickAviso(event, aviso)
  }

  return (
    <ModalComponent
      skin="with-info"
      width={width}
      visible={visible}
      onClose={closeModalHandler}
      title={title}
      subtitle={subtitle}
      footer={<ModalFooter primaryButtonAction={primaryButtonAction} primaryButtonText={primaryButtonText} />}
    >
      <ModalBodyComponent>
        <ContainerFluid>
          <Row>
            <Col noGutter>
              <ModalBodyContent>
                {loading ? (
                  <ListadoAvisosPlaceholder total={TOTAL_CARDS_PLACEHOLDER} />
                ) : avisos && avisos.length > 0 ? (
                  avisos.map((aviso, index) => {
                    return (
                      <CardContainer key={aviso}>
                        <Card
                          disableLink={false}
                          aviso={aviso}
                          index={index}
                          onClick={({ event }) => clickAvisoHandler(event, aviso)}
                          ubicacion="Modal - Listado Avisos - Recomendados"
                          link={`${makeFichaAvisoURL({
                            ...aviso,
                            empresa: {
                              denominacion: aviso.empresa,
                              confidencial: aviso.empresa === CONFIDENCIAL,
                            },
                          })}${labsParams}`}
                        />
                      </CardContainer>
                    )
                  })
                ) : (
                  <>{emptyComponent}</>
                )}
              </ModalBodyContent>
            </Col>
          </Row>
        </ContainerFluid>
      </ModalBodyComponent>
    </ModalComponent>
  )
}

export default ModalAvisosRecomendados
